<script>
  import { createEventDispatcher } from 'svelte';

  export let style = '';
  export let disabled = false;
  
  const dispatch = createEventDispatcher()
</script>

<button disabled={disabled} on:click={(e) => dispatch('click', e)} class="pure-button" style={style}>
  <slot/>
</button>


<style>
  button {
    color: var(--tertiary);
    font-weight: 200;
    border: #ddd solid 1px;
    border-radius: 3px;
    background-color: var(--background);
    margin: auto;
    display: flex;
    align-items: baseline;
    font-size: 0.8em;
  }
</style>